function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = n() : "function" == typeof define && define.amd ? define("@asctech/vue-osu-footer", [], n) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@asctech/vue-osu-footer"] = n() : t["@asctech/vue-osu-footer"] = n();
}(window, function () {
  return r = {}, o.m = e = [function (e, t, n) {
    (function (t) {
      function n(t) {
        return t && t.Math == Math && t;
      }

      e.exports = n("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || n("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || n("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || n("object" == _typeof(t) && t) || Function("return this")();
    }).call(this, n(17));
  }, function (t, n) {
    t.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, n, e) {
    "use strict";

    e.r(n);
    var r = e(3),
        o = e.n(r);

    for (var i in r) {
      "default" !== i && function (t) {
        e.d(n, t, function () {
          return r[t];
        });
      }(i);
    }

    n["default"] = o.a;
  }, function (t, n, e) {
    "use strict";

    e(15), Object.defineProperty(n, "__esModule", {
      value: !0
    }), n["default"] = void 0;
    var r = {
      props: {
        address: {
          type: String,
          "default": "Columbus, Ohio 43210"
        },
        alternateFormatContact: {
          type: String,
          "default": "webmaster@osu.edu"
        },
        copyrightYear: {
          type: String,
          "default": function _default() {
            return "".concat(new Date().getFullYear());
          }
        }
      }
    };
    n["default"] = r;
  }, function (t, n, e) {}, function (t, n, e) {
    var r = e(6),
        o = e(18),
        i = e(23);
    t.exports = r ? function (t, n, e) {
      return o.f(t, n, i(1, e));
    } : function (t, n, e) {
      return t[n] = e, t;
    };
  }, function (t, n, e) {
    var r = e(8);
    t.exports = !r(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (t, n, e) {
    "use strict";

    e.d(n, "a", function () {
      return r;
    }), e.d(n, "b", function () {
      return o;
    });

    var r = function r(t, n) {
      var e = n._c;
      return e("div", n._g(n._b({
        attrs: {
          id: "osu-footer",
          "aria-labelledby": "osu-footer"
        }
      }, "div", n.data.attrs, !1), n.listeners), [e("img", {
        staticClass: "osu-logo",
        attrs: {
          alt: "OSU logo",
          src: "https://bux.osu.edu/img/osu-logos/horiz/osu-horiz-white.svg"
        }
      }), n._v(" "), e("p", [n._v("©" + n._s(n.props.copyrightYear) + ", The Ohio State University")]), n._v(" "), e("p", [n._v(n._s(n.props.address))]), n._v(" "), e("p", [n.props.phone ? [n._v("\n      Phone: " + n._s(n.props.phone) + " \n      "), n.props.fax || n.props.contact ? [n._v("\n        | \n      ")] : n._e()] : n._e(), n._v(" "), n.props.fax ? [n._v("\n      Fax: " + n._s(n.props.fax) + " \n      "), n.props.contact ? [n._v("\n        | \n      ")] : n._e()] : n._e(), n._v(" "), n.props.contact ? [e("a", {
        attrs: {
          href: "mailto:" + n.props.contact
        }
      }, [n._v("\n        Contact\n      ")])] : n._e()], 2), n._v(" "), e("p", [n._v("\n    If you have trouble accessing this page and\n    need to request an alternate format, contact\n    "), e("a", {
        attrs: {
          href: "mailto:" + n.props.alternateFormatContact
        }
      }, [n._v("\n      " + n._s(n.props.alternateFormatContact) + "\n    ")])]), n._v(" "), n._t("default")], 2);
    },
        o = [];
  }, function (t, n) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, n) {
    var e = {}.hasOwnProperty;

    t.exports = function (t, n) {
      return e.call(t, n);
    };
  }, function (t, n, e) {
    var r = e(0),
        o = e(5);

    t.exports = function (n, e) {
      try {
        o(r, n, e);
      } catch (t) {
        r[n] = e;
      }

      return e;
    };
  }, function (t, n, e) {
    var r = e(12),
        o = Function.toString;
    "function" != typeof r.inspectSource && (r.inspectSource = function (t) {
      return o.call(t);
    }), t.exports = r.inspectSource;
  }, function (t, n, e) {
    var r = e(0),
        o = e(10),
        i = r["__core-js_shared__"] || o("__core-js_shared__", {});
    t.exports = i;
  }, function (t, n, e) {
    "use strict";

    function r(t, n, e, r, o, i, u, c) {
      var a,
          f = "function" == typeof t ? t.options : t;
      if (n && (f.render = n, f.staticRenderFns = e, f._compiled = !0), r && (f.functional = !0), i && (f._scopeId = "data-v-" + i), u ? (a = function a(t) {
        (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(u);
      }, f._ssrRegister = a) : o && (a = c ? function () {
        o.call(this, this.$root.$options.shadowRoot);
      } : o), a) if (f.functional) {
        f._injectStyles = a;
        var s = f.render;

        f.render = function (t, n) {
          return a.call(n), s(t, n);
        };
      } else {
        var p = f.beforeCreate;
        f.beforeCreate = p ? [].concat(p, a) : [a];
      }
      return {
        exports: t,
        options: f
      };
    }

    e.d(n, "a", function () {
      return r;
    });
  }, function (t, n, e) {
    "use strict";

    e.r(n);
    var r = e(7),
        o = e(2);

    for (var i in o) {
      "default" !== i && function (t) {
        e.d(n, t, function () {
          return o[t];
        });
      }(i);
    }

    e(31);
    var u = e(13),
        c = Object(u.a)(o["default"], r.a, r.b, !0, null, null, null);
    n["default"] = c.exports;
  }, function (t, n, e) {
    var r = e(16),
        o = Date.prototype,
        i = o.toString,
        u = o.getTime;
    new Date(NaN) + "" != "Invalid Date" && r(o, "toString", function () {
      var t = u.call(this);
      return t == t ? i.call(this) : "Invalid Date";
    });
  }, function (t, n, e) {
    var c = e(0),
        a = e(5),
        f = e(9),
        s = e(10),
        r = e(11),
        o = e(24),
        i = o.get,
        p = o.enforce,
        l = String(String).split("String");
    (t.exports = function (t, n, e, r) {
      var o = !!r && !!r.unsafe,
          i = !!r && !!r.enumerable,
          u = !!r && !!r.noTargetGet;
      "function" == typeof e && ("string" != typeof n || f(e, "name") || a(e, "name", n), p(e).source = l.join("string" == typeof n ? n : "")), t !== c ? (o ? !u && t[n] && (i = !0) : delete t[n], i ? t[n] = e : a(t, n, e)) : i ? t[n] = e : s(n, e);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && i(this).source || r(this);
    });
  }, function (t, n) {
    var e;

    e = function () {
      return this;
    }();

    try {
      e = e || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (e = window);
    }

    t.exports = e;
  }, function (t, n, e) {
    var r = e(6),
        o = e(19),
        i = e(21),
        u = e(22),
        c = Object.defineProperty;
    n.f = r ? c : function (t, n, e) {
      if (i(t), n = u(n, !0), i(e), o) try {
        return c(t, n, e);
      } catch (t) {}
      if ("get" in e || "set" in e) throw TypeError("Accessors not supported");
      return "value" in e && (t[n] = e.value), t;
    };
  }, function (t, n, e) {
    var r = e(6),
        o = e(8),
        i = e(20);
    t.exports = !r && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, n, e) {
    var r = e(0),
        o = e(1),
        i = r.document,
        u = o(i) && o(i.createElement);

    t.exports = function (t) {
      return u ? i.createElement(t) : {};
    };
  }, function (t, n, e) {
    var r = e(1);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(String(t) + " is not an object");
      return t;
    };
  }, function (t, n, e) {
    var o = e(1);

    t.exports = function (t, n) {
      if (!o(t)) return t;
      var e, r;
      if (n && "function" == typeof (e = t.toString) && !o(r = e.call(t))) return r;
      if ("function" == typeof (e = t.valueOf) && !o(r = e.call(t))) return r;
      if (!n && "function" == typeof (e = t.toString) && !o(r = e.call(t))) return r;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, n) {
    t.exports = function (t, n) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: n
      };
    };
  }, function (t, n, e) {
    var r,
        o,
        i,
        u = e(25),
        c = e(0),
        a = e(1),
        f = e(5),
        s = e(9),
        p = e(26),
        l = e(30),
        d = c.WeakMap;

    if (u) {
      var v = new d(),
          _ = v.get,
          y = v.has,
          h = v.set;
      r = function r(t, n) {
        return h.call(v, t, n), n;
      }, o = function o(t) {
        return _.call(v, t) || {};
      }, i = function i(t) {
        return y.call(v, t);
      };
    } else {
      var g = p("state");
      l[g] = !0, r = function r(t, n) {
        return f(t, g, n), n;
      }, o = function o(t) {
        return s(t, g) ? t[g] : {};
      }, i = function i(t) {
        return s(t, g);
      };
    }

    t.exports = {
      set: r,
      get: o,
      has: i,
      enforce: function enforce(t) {
        return i(t) ? o(t) : r(t, {});
      },
      getterFor: function getterFor(e) {
        return function (t) {
          var n;
          if (!a(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
          return n;
        };
      }
    };
  }, function (t, n, e) {
    var r = e(0),
        o = e(11),
        i = r.WeakMap;
    t.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (t, n, e) {
    var r = e(27),
        o = e(29),
        i = r("keys");

    t.exports = function (t) {
      return i[t] || (i[t] = o(t));
    };
  }, function (t, n, e) {
    var r = e(28),
        o = e(12);
    (t.exports = function (t, n) {
      return o[t] || (o[t] = void 0 !== n ? n : {});
    })("versions", []).push({
      version: "3.6.5",
      mode: r ? "pure" : "global",
      copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, n) {
    t.exports = !1;
  }, function (t, n) {
    var e = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++e + r).toString(36);
    };
  }, function (t, n) {
    t.exports = {};
  }, function (t, n, e) {
    "use strict";

    var r = e(4);
    e.n(r).a;
  }], o.c = r, o.d = function (t, n, e) {
    o.o(t, n) || Object.defineProperty(t, n, {
      enumerable: !0,
      get: e
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (n, t) {
    if (1 & t && (n = o(n)), 8 & t) return n;
    if (4 & t && "object" == _typeof(n) && n && n.__esModule) return n;
    var e = Object.create(null);
    if (o.r(e), Object.defineProperty(e, "default", {
      enumerable: !0,
      value: n
    }), 2 & t && "string" != typeof n) for (var r in n) {
      o.d(e, r, function (t) {
        return n[t];
      }.bind(null, r));
    }
    return e;
  }, o.n = function (t) {
    var n = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return o.d(n, "a", n), n;
  }, o.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, o.p = "/dist/", o(o.s = 14);

  function o(t) {
    if (r[t]) return r[t].exports;
    var n = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  var e, r;
});